import React, { cloneElement, useState, useEffect } from 'react';
import { parseProps } from '../@base/@uteis';

export const Validation = (_props) => {
  const props = parseProps(_props);
  const propsChildren = props.children.props;
  const [mandatory, setMandatory] = useState(false);

  useEffect(() => {
    let isValidResult = null;
    if (propsChildren.mandatory
      && propsChildren.value !== null
      && (propsChildren.value.length === 0
        || (typeof propsChildren.value === 'string' && propsChildren.value.trim().length === 0)
      )
    ) {
      setMandatory(true);
      isValidResult = false;
    } else {
      setMandatory(false);
      isValidResult = true;
    }

    if (props.setInvalid) {
      const result = props.setInvalid();
      if (isValidResult) isValidResult = result.valid;
    }

    if (props.isValid) props.isValid(isValidResult);
  }, [props.children.props.value]);

  let kwarg = {};

  if (mandatory) {
    kwarg = {
      invalid: true,
      feedback_message: 'Preenchimento obrigatório',
    };
  } else if (props.setInvalid) {
    const result = props.setInvalid();
    if (!result.valid) {
      kwarg = {
        invalid: true,
        feedback_message: result.message,
      };
    }
  }

  return cloneElement(props.children, kwarg);
};

const onChangeHandle = (e, propsInput, updateParameter, parameter) => {
  let { value } = e.target;
  const { percent } = propsInput;

  if (percent) value /= 100;
  value = value.toString();

  updateParameter({
    ...parameter,
    value,
  });
};

export const preparingInput = (
  input, parameter, props, changeValidHandler,
) => {
  const { percent } = input.props;
  return (
    <Validation isValid={changeValidHandler}>
      {React.cloneElement(input, {
        value: percent ? (parameter.value * 100).toFixed(0) : parameter.value,
        mandatory: parameter.parameter.mandatory,
        onChange: (e) => { onChangeHandle(e, input.props, props.updateParameter, parameter); },
      })}
    </Validation>
  );
};

export const getParameter = (parametersList, key) => parametersList.filter(
  (p) => p.parameter.name === key,
)[0];

export const onValidHandler = (setInputValid, parameter) => (e) => {
  setInputValid((prev) => ({
    ...prev,
    [parameter.parameter.name]: e,
  }));
};

export const handleInputValid = (inputValid, props) => {
  const _componetInvalid = Object.values(inputValid).includes(false);
  props.componentIsValid(!_componetInvalid);
};

export default null;
